import React from 'react';

const GridStyledList = ({ content, header }) => {
  return (
    <>
      <div className='text-4xl font-bold text-center'>{header}</div>
      <div className={`grid md:grid-cols-2 ${content.length > 6 ? 'xl:grid-cols-4' : 'lg:grid-cols-3'}  gap-x-8 gap-y-12`}>
        {
          content.map(contentItem => (
            <div className="flex gap-x-4" key={contentItem.title}>
              <img src={contentItem.icon} className='rounded-full size-16' alt='icon' />

              <div className='space-y-2'>
                <div className='font-bold text-xl'>{contentItem.title}</div>
                <p>{contentItem.body}</p>
              </div>
            </div>
          ))
        }
      </div>
    </>
  );
}

export default GridStyledList;
